<template>
  <hypto-popup :title="subscriptionOptions.title">
    <template v-slot:body>
      <p>Do you want to <b>{{subscriptionOptions.type}} {{subscriptionOptions.text}}</b> email subscription?</p>
    </template>

    <template v-slot:footer>
      <button class="primary-btn" @click="doAction" :disabled="isDisableButton">Proceed</button>
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'

import ApiServices from '@/services/api/userProfile'
import { openPopup } from '@/utils/helpers'
import formMixins from '@/mixins/formMixins'

export default {
  name: 'ToggleEmailSubscriptions',
  components: { HyptoPopup },
  props: {
    subscriptionOptions: Object
  },
  mixins: [formMixins],
  methods: {
    openPopup,
    createParams () {
      return {
        category: this.subscriptionOptions.category
      }
    },
    doAction () {
      const params = this.createParams()

      if (this.subscriptionOptions.type === 'Enable') {
        this.enableSubscription(params)
      } else {
        this.disableSubscription(params)
      }
    },
    enableSubscription (params) {
      ApiServices.enableEmailSubscription(params).then((response) => {
        this.handleResponse(response)
      })
    },
    disableSubscription (params) {
      ApiServices.disableEmailSubscription(params).then((response) => {
        this.handleResponse(response)
      })
    },
    handleResponse (response) {
      if (response.success) {
        this.$emit('refreshSubscription')
        this.successToastMsg(response.message)
        this.openPopup(null)
      } else {
        this.errorToastMsg(response.message)
      }
      this.enableButton()
    }
  }
}
</script>

<style scoped lang="scss">
  p {
    font-size: 15px;
    text-align: center;
  }

  .mobile {
    p {
      text-align: left !important;
    }
  }
</style>
